var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({padding: _vm.padding})},[_c('img',{staticClass:"spinner",style:({width: _vm.size}),attrs:{"src":require("./images/spinner.png"),"alt":"","aria-hidden":"true"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }